<template>
  <div class="c-list__filter">
    <button class="c-list__button" :class="{ open: isActive }" @click="togglePanel">
      {{ label }} <span v-if="selectedCount > 0">{{ selectedCount }}</span>
    </button>
    <div class="c-list__filters" :class="{ open: isActive }">
      <div class="c-list__header">
        <div>
          <h1>{{ label }}</h1>
          <button
            type="button"
            class="c-list-filters-close"
            @click="togglePanel"
            aria-label="Close Filters Button"
          ></button>
        </div>
      </div>
      <div class="c-list__filters-container">
        <button class="c-list__close" @click="togglePanel">X</button>
        <span class="c-list__results">
          <template v-if="pageInfo.totalCount >= 0">
            <span>{{ pageInfo.totalCount }}</span> Results Found
          </template>
          <template v-else>&nbsp;</template>
        </span>
        <button class="c-list__clear--mobile" @click="clearTopics()">Clear Filters</button>
        <div class="topics">
          <div class="topic" v-for="topic in topics" :key="topic.id">
            <p class="topic__name">{{ topic.name }}</p>
            <ul>
              <li v-for="item in topic.children" :key="item.id">
                <label class="c-checkbox" :for="`topic-${item.id}`">
                  <input
                    type="checkbox"
                    :name="topic.name"
                    :checked="isSelected(item.id)"
                    :id="`topic-${item.id}`"
                    :value="item.id"
                    @change="toggleTopic"
                  />
                  {{ item.title.value }}
                </label>
              </li>
            </ul>
          </div>
        </div>
        <button class="c-list__clear" @click="clearTopics()">Clear Filters</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CIS-Resource-PagedListing-Filter',
  props: {
    label: {
      type: String,
      default: ''
    },
    topics: {
      type: Array,
      default: () => []
    },
    selectedTopics: {
      type: Array,
      default: () => []
    },
    pageInfo: {
      type: Object,
      default: () => ({})
    }
  },
  components: {},
  emits: ['toggleTopic', 'clearTopics'],
  data: () => {
    return {
      isActive: false
    };
  },
  mounted() {
    document.onclick = (e) => {
      const filterElement = document.getElementsByClassName('c-list__filter')[0];
      if (filterElement && !filterElement.contains(e.target)) {
        this.togglePanel(false);
      }
    };
  },
  methods: {
    togglePanel(active) {
      if (typeof active === 'boolean') {
        this.isActive = active;
      } else {
        this.isActive = !this.isActive;
      }
    },
    toggleTopic(e) {
      const topicGroup = e.target?.name;
      const topicId = e.target?.value;
      this.$emit('toggleTopic', topicId, topicGroup);
    },
    clearTopics() {
      this.$emit('clearTopics');
    },
    isSelected(topicId) {
      return this.selectedTopics.some((t) => t.id === topicId);
    }
  },
  computed: {
    selectedCount() {
      return this.selectedTopics?.length || 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/components/checkbox.scss';

.c-list__filter {
  position: relative;

  .c-list__button {
    position: relative;
    border: solid 0.1rem $blue;
    @include font-styles('Arial Narrow', 1.6rem, 400, normal, 2rem, 0, $blue);
    text-transform: uppercase;
    padding: 1.1rem 1.5rem 1.1rem 4.5rem;
    border-radius: 0.5rem;
    background-color: transparent;
    background-image: url(~@/assets/images/icon-filterbytopic-blue.svg);
    background-position: 1.5rem 50%;
    background-repeat: no-repeat;

    &.open {
      background-color: $blue;
      color: $white;
      background-image: url(~@/assets/images/icon-filterbytopic-white.svg);
    }

    span {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      font-size: 1.3rem;
      line-height: 1.6rem;
      height: 1.8rem;
      width: 1.8rem;
      color: $white;
      background-color: $orange;
      border-radius: 50%;
      display: inline-block;
    }
  }

  .c-list__close {
    display: none;
    @include font-styles('Arial', 2.5rem, 200, normal, normal, 0, $blue);
    background: transparent;
    border: none;
    position: absolute;
    top: 1rem;
    right: 1rem;

    @include desktop-up {
      display: block;
    }
  }

  .c-list__results {
    @include font-styles('Arial', 1.6rem, 200, normal, 1.8rem, 0, $gray);

    @include desktop-up {
      font-size: 2rem;
      line-height: 2.6rem;
    }

    span {
      font-weight: 400;
    }
  }

  .c-list__results-top {
    float: right;
    line-height: 4rem;

    @include desktop-up {
      float: none;
    }
  }

  .c-list__clear {
    display: none;
    background: transparent;
    border: none;
    @include font-styles('Arial', 1.6rem, 500, normal, 2rem, 0, $blue);

    @include desktop-up {
      display: block;
    }

    &:hover {
      text-decoration: underline;
    }

    &--mobile {
      background: transparent;
      border: none;
      @include font-styles('Arial', 1.6rem, 300, normal, 2rem, 0, $lite-gray);
      float: right;

      @include desktop-up {
        display: none;
      }
    }
  }

  .c-list__filters {
    display: none;
    background-color: #ffffff;
    box-shadow: 0 0 3.5rem 0 rgba(0, 0, 0, 0.35);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    @include desktop-up {
      position: absolute;
      top: 5rem;
      width: auto;
      height: auto;
      padding: 2rem 3.5rem;
    }

    &:before {
      @include desktop-up {
        content: ' ';
        position: absolute;
        bottom: 100%;
        left: 7rem;
        height: 0;
        width: 0;
        border: solid transparent;
        border-bottom-color: #fff;
        border-width: 1rem;
      }
    }

    &.open {
      display: inline-block;
      z-index: 9999;

      @include desktop-down {
        overflow: scroll;
      }
    }

    &-container {
      padding: 0 4rem;

      @include desktop-up {
        padding: 0;
      }
    }

    .topics {
      margin: 1rem 0;

      @include desktop-up {
        display: flex;
        margin: 2.5rem 0;
      }

      .topic {
        border-top: solid 0.1rem $divider;
        padding: 2rem 0 0 0;

        @include desktop-up {
          border-top: none;
          border-left: solid 0.1rem $divider;
          padding: 0 0 0 4rem;
        }

        @include large-desktop-up {
          margin-left: -2rem;
        }

        &:first-child {
          @include desktop-up {
            margin-left: 0;
            border-left: none;
            padding-left: 0;
            padding-right: 2rem;
          }

          @include large-desktop-up {
            padding-right: 0;
          }
        }

        &__name {
          @include font-styles('Arial', 1.4rem, 600, normal, 1.6rem, 0, $dark-gray);
          text-transform: uppercase;
        }
      }
    }

    ul {
      margin: 2rem 0 0 0;

      @include desktop-up {
        border: none;
        columns: 1 auto;
        margin-bottom: -2rem;
      }

      @include large-desktop-up {
        columns: 2 auto;
      }

      li {
        margin: 0 0 2rem 0;
        white-space: nowrap;

        @include desktop-up {
          display: inline-block;
          padding-top: 0.2rem;
          margin-right: 2rem;
          margin-bottom: 1rem;
        }

        &:before {
          display: none;
        }

        &::marker {
          content: '';
          color: $white;
        }

        label {
          @include font-styles('Arial', 1.8rem, 200, normal, 2.4rem, 0, $dark-gray);
          margin: 0;
          margin-bottom: 1rem;
          cursor: pointer;

          input {
            cursor: pointer;
          }

          &.c-checkbox {
            gap: 2rem;

            input[type='checkbox'] {
              width: 2.5rem;
              height: 2.5rem;
              transform: translateY(0);

              &::before {
                width: 2.5rem;
                height: 2.5rem;
                background: $blue url(~@/assets/images/icon-checkmark-white.svg) 50% no-repeat;
                box-shadow: none;
              }
            }
          }
        }
      }
    }
  }

  .c-list__header {
    min-height: 7rem;
    display: flex;
    align-items: center;
    background: rgb(0, 123, 176);
    background: linear-gradient(180deg, rgba(0, 123, 176, 1) 0%, rgba(0, 73, 110, 1) 100%);
    margin-bottom: 2rem;

    @include desktop-up {
      display: none;
    }

    h1 {
      @include font-styles('Arial', 2rem, 300, normal, normal, 0, #fff);
      flex: 1 0 0%;
      background-clip: unset;
      -webkit-background-clip: unset;
      -webkit-text-fill-color: unset;
      background-repeat: no-repeat;
      background-position: left center;
      background-size: auto;
      background-color: transparent;
      background-image: url(~@/assets/images/icon-filterbytopic-white.svg);
      padding-left: 3.5rem;
      margin: 0;
      margin-left: 2rem;
    }

    .c-list-filters-close {
      position: absolute;
      top: 1.5rem;
      right: 1.5rem;
      text-align: right;
      flex: 0 0 10%;
      width: 4rem;
      height: 4rem;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 2rem;
      background-color: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      margin: 0;
    }

    .c-search-clear,
    .c-list-filters-close {
      background-image: url(~@/assets/images/icon-close-white.svg);
    }
  }
}
</style>
